// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#map {
  width: 100%;
  height: 100%;
}

.search-bar {
  border-radius: 4px;
  line-height: 1.6;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

#search-container {
  top: 4px;
  left: 4px;
  right: 4px;
  position: absolute;
  padding: 4px;
}
#search-container app-venue-suggestion {
  width: 100%;
}

.slides-container {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

.swiper-slide {
  align-self: flex-end;
}

app-venue-suggestion {
  width: 90%;
}

.map-toggle-container {
  height: 48px;
  margin: 4px 0;
  background: white;
  border-radius: 4px;
}

.mode-icon {
  padding: 10px;
  height: 30px;
  width: 30px;
  border-radius: 4px;
}

.mode-icon {
  background: white;
  color: #4C006A;
  transition: 0.3s linear;
}

.mode-icon.selected {
  background: #4C006A;
  color: white;
  transition: 0.3s linear;
}

.full-height {
  height: 100%;
}

.sidebar {
  overflow: auto;
  height: 100%;
}
.sidebar app-venue-suggestion {
  margin: 5px auto;
}
.sidebar .title {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: black;
  opacity: 0.5;
}

.hint {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 14px;
  background: white;
}
.hint p {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0 8px;
}
.hint span {
  font-size: 14px;
}
.hint ion-icon {
  height: 44px;
  width: 44px;
  place-self: center;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/map/components/map-search-venue/map-search-venue.component.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;AAAJ;;AAIE;EACE,kBAAA;EACA,gBAAA;AADJ;;AAIE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AADJ;;AAIE;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AADJ;AAGI;EACE,WAAA;AADN;;AAKE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AAFJ;;AAKE;EACE,oBAAA;AAFJ;;AAKE;EACE,UAAA;AAFJ;;AAKE;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;;AAKE;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAFJ;;AAKE;EACE,iBAAA;EACA,cAAA;EACA,uBAAA;AAFJ;;AAKE;EACE,mBAAA;EACA,YAAA;EACA,uBAAA;AAFJ;;AAKE;EACE,YAAA;AAFJ;;AAKE;EAKE,cAAA;EACA,YAAA;AANJ;AACI;EACE,gBAAA;AACN;AAKI;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AAHN;;AAOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AAJJ;;AAOE;EACE,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAJJ;AAMI;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AAJN;AAOI;EACE,eAAA;AALN;AAQI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AANN;;AAUE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAPJ","sourcesContent":["\n#map {\n    width: 100%;\n    height: 100%;\n  }\n  \n  \n  .search-bar {\n    border-radius: 4px;\n    line-height: 1.6;\n  }\n  \n  .search-bar > div {\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    place-items: center;\n  }\n  \n  #search-container {\n    top: 4px;\n    left: 4px;\n    right: 4px;\n    position: absolute;\n    padding: 4px;\n  \n    app-venue-suggestion {\n      width: 100%;\n    }\n  }\n  \n  .slides-container {\n    position: absolute;\n    bottom: 20px;\n    left: 0;\n    right: 0;\n  }\n  \n  .swiper-slide {\n    align-self: flex-end;\n  }\n  \n  app-venue-suggestion {\n    width: 90%;\n  }\n  \n  .map-toggle-container {\n    height: 48px;\n    margin: 4px 0;\n    background: white;\n    border-radius: 4px;\n  }\n  \n  .mode-icon {\n    padding: 10px;\n    height: 30px;\n    width: 30px;\n    border-radius: 4px;\n  }\n  \n  .mode-icon {\n    background: white;\n    color: #4C006A;\n    transition: 0.3s linear;\n  }\n  \n  .mode-icon.selected {\n    background: #4C006A;\n    color: white;\n    transition: 0.3s linear;\n  }\n  \n  .full-height {\n    height: 100%;\n  }\n  \n  .sidebar {\n    app-venue-suggestion {\n      margin: 5px auto;\n    }\n  \n    overflow: auto;\n    height: 100%;\n  \n    .title {\n      width: 90%;\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n  \n  .loading-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 10;\n    background: black;\n    opacity: 0.5;\n  }\n  \n  .hint {\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n    padding: 14px;\n    background: white;\n  \n    p {\n      font-size: 12px;\n      color: black;\n      margin: 0;\n      padding: 0 8px;\n    }\n  \n    span {\n      font-size: 14px;\n    }\n  \n    ion-icon {\n      height: 44px;\n      width: 44px;\n      place-self: center;\n    }\n  }\n  \n  .center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
